// @flow

import React from 'react';
import { Radar } from 'react-chartjs-2';
import { I18n } from 'react-redux-i18n';
import { roundValue } from '../../../../../utils/formatUtils';
import { ATTRACTIVE_SCORE_RADAR_CHART_STYLE } from '../../../../../const';

type Props = {
  scarcityNote: number,
  uniquenessNote: number,
  trendinessNote: number,
};

function AttractiveScoreRadarChart({ scarcityNote, uniquenessNote, trendinessNote }: Props) {
  const {
    textColor, backgroundColor, hoverColor, titleFontSize,
  } = ATTRACTIVE_SCORE_RADAR_CHART_STYLE;

  const RadarData = {
    labels: [
      I18n.t('attractiveScore.scarcity.title'),
      I18n.t('attractiveScore.differentiation.title'),
      I18n.t('attractiveScore.trendiness.title'),
    ],
    datasets: [
      {
        borderColor: textColor,
        pointBackgroundColor: textColor,
        pointHoverBackgroundColor: hoverColor,
        backgroundColor,
        data: [scarcityNote, uniquenessNote, trendinessNote],
      },
    ],
  };

  const RadarOptions = {
    legend: {
      display: false,
    },
    tooltips: {
      callbacks: {
        label(context, metadata) {
          const score = metadata.datasets[context.datasetIndex].data[context.index];
          return I18n.t('attractiveScore.score', { score: roundValue(score) });
        },
        title(context, metadata) {
          return metadata.labels[context[0].index];
        },
      },
    },
    scale: {
      ticks: {
        min: 0,
        max: 10,
      },
      angleLines: {
        lineWidth: 1,
      },
      pointLabels: {
        fontSize: titleFontSize,
        fontColor: textColor,
      },
    },
  };
  return (
    <div className="radar-chart">
      <Radar data={RadarData} options={RadarOptions} />
    </div>
  );
}

export default AttractiveScoreRadarChart;
